// extracted by mini-css-extract-plugin
module.exports = {"wrap":"SelectDefaultContact_wrap__2_xVo","item":"SelectDefaultContact_item__94dMB","isLoading":"SelectDefaultContact_isLoading__2WoOo"};